export default {
	methods: 
    {		
		async nuevoModal()
		{
		  await this.resetGlobal({state: 'indexData'})
		  await this.updateGlobal({state: 'openModal/modal/value',    data: true });
		  await this.updateGlobal({state: 'openModal/modal/title',    data: 'Nuevo Paciente'});
		  await this.updateGlobal({state: 'openModal/modal/modal',    data: 'Nuevo'});
		},	
	},
}